
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Checkbox, CircularProgress, IconButton, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
// import StarOutlineIcon from '@mui/icons-material/StarOutline';
// import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
// import StarIcon from '@mui/icons-material/Star';
// import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import { bytesToMegabytes, downloadS3File, fileFormat, getFileType, removeExtension, sizeConverter, timeStampToNumberedDateString } from '../../../utils/commonServices';
import { makeStyles } from "@mui/styles";
import CustomTooltip from '../../../components/CustomTooltip';
import { useDispatch, useSelector } from 'react-redux';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import { useNavigate } from 'react-router-dom';
// import { setAllMediaFilesArray } from '../../../redux/mediaFilesSlice';
// import CustomScrollToBottom from '../../../components/CustomScrollToBottom';
// import { BRANDBOX_OPTIONS } from '../../../constants/staticData';
// import DeleteIcon from '@mui/icons-material/Delete';

import MediaPreview from '../../../components/MediaPreview';
import usePendingVerificationActions from '../usePendingVerificationActions';
import CustomButton from '../../../components/CustomButton';

const useStyles = makeStyles((theme) => ({
    checkboxRoot: {
        pointerEvents: 'none',
      },
    container: {
        width:'100%',
        borderCollapse: 'collapse',
       // paddingRight:'4%'
       scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        '&::-webkit-scrollbar': {
                 display : 'none'
               }
    },
    tableRowHead:{
        textAlign:'left',
        verticalAlign:'top',
        color:'#08231B',
        fontSize:'15px',
        fontFamily: "Rubik",
        fontWeight:500,
        letterSpacing: '0.75px',
        zIndex: 15
    },
    tableRowData:{
        borderBottom:'2px solid #EBEBEB',
        // height:{xs:'50px',md:'55px',lg:'60px', xl:'68px'},
        // height:'62px',
        backgroundColor:'transparent',
        fontFamily: "Rubik",
       // textAlign:'left',
        width:'100%',
        fontSize:'15px',
        // font: 'normal normal 600 15px/18px ',
        fontWeight:600,
        color:'#08231B',
        letterSpacing: '0.75px',
        zIndex: 15,
        '&:last-child':{
            borderBottom:'none'
         }
    },
 
  }));

const UsersTable = (props) => {

    const classes = useStyles();
    const {files, popup, expanded, setExpanded}= props
    const userReducer = useSelector((state) => state.userReducer);
    const commonReducer = useSelector((state) => state.root.commonReducer);
      const {resendUnverifiedUserLink, approveUser } = usePendingVerificationActions()
 

 

  return (
   
           <Box mt={3} className='flex col' sx={{minWidth:'600px'}}>
                <Box sx={{overflowY:'scroll', height: popup == true ? '30vh':'60vh'}}>

        
           {/* {  userReducer.all_users?.length === 0 ?  <Typography sx={{fontSize: 30, color: '#878887', fontWeight: 300, textAlign: 'center', mt:10}} >No Users to view. </Typography> : 
         <> */}
             <Box sx={{ display:'flex', alignItems:'center'}} mb={{xs:2,xl:3.5}}>
                    <Box    style={{ width:'20%'}}><Typography  sx={{fontSize: {xs:'10px',md:'13px',lg:'14.67px',xl:'21px'}, fontFamily: 'Rubik' , fontWeight: 800, color:'#08231B'}}>Name</Typography></Box>

                    <Box  style={{ marginLeft: '1%', width:'20%'}}><Typography textAlign='left' sx={{fontSize: {xs:'10px',md:'13px',lg:'14.67px',xl:'21px'},  fontFamily: 'Rubik' , fontWeight: 800, color:'#08231B'}}>Email</Typography></Box>

                    <Box  style={{  marginLeft: '1%', width: '20%'}}><Typography textAlign='left' sx={{fontSize: {xs:'10px',md:'13px',lg:'14.67px',xl:'21px'}, fontFamily: 'Rubik' , fontWeight: 800, color:'#08231B' }}>Organization Name</Typography></Box>

                    <Box  style={{  marginLeft: '1%', width: '15%'}}><Typography textAlign='left' sx={{fontSize: {xs:'10px',md:'13px',lg:'14.67px',xl:'21px'}, fontFamily: 'Rubik', fontWeight: 800, color:'#08231B'}}>Status</Typography></Box>


                    {/* <Box   style={{ marginLeft: '1%',  width: '20%'}}><Typography textAlign='left' sx={{fontSize: {xs:'10px',md:'13px',lg:'14.67px',xl:'21px'}, fontFamily: 'Rubik', fontWeight: 800, color:'#08231B'}}>Action</Typography></Box> */}

                    {/* <Box   style={{ marginLeft: '1%',  width: '10%'}}><Typography textAlign='center' sx={{fontSize: {xs:'10px',md:'13px',lg:'14.67px',xl:'21px'}, fontFamily: 'Rubik', fontWeight: 800, color:'#08231B'}}></Typography></Box> */}
              

                    <Box flex={1} sx={{ display:'flex',  minWidth:'15%', justifyContent:'end'}}  ><Typography  sx={{fontSize: {xs:'10px',md:'13px',lg:'14.67px',xl:'21px'}, fontFamily: 'Rubik', color:'#08231B',display:'flex', alignItems:'center', fontWeight:800, justifyContent:'end'}}>Action</Typography></Box>
                </Box>
                {/* { */}
         {/* userReducer.all_users?.map((user)=> (  */}
                
                <Box >
                     {(userReducer?.is_loading == true)  ? <Box sx={{width:'100%',mt:15}}>
                           <Typography variant='h3' textAlign='center'>Loading...</Typography>
                     </Box> :  files?.length  == 0 ? (<Typography textAlign={'center'} mt={'5%'}>{'No users to show'}</Typography>) :  files?.map((user, index) => (
                        <Box className={classes.tableRowData}  key={user?.id} sx={{display:'flex',  alignItems:'center', height: popup == true ?{md:'40px',lg:'45px', xl:'60px'}:{lg:'55px',xl:'65px'}, overflowY:'scroll'}}>
                         
                
                    <CustomTooltip title = {user?.name} >
                            <Box    style={{ width: '20%'}}><Typography  sx={{fontSize: {xs:'10px',md:'11px',lg:'13px',xl:'19px', whiteSpace: "nowrap", overflowX: "clip"}, fontWeight:400, fontFamily: 'Rubik', cursor:'pointer'}}>{user?.name}</Typography></Box>
                    </CustomTooltip> 

                            <Box    style={{  marginLeft: '1%', width:'20%'}}><Typography textAlign='left' sx={{fontSize: {xs:'8px',md:'9px',lg:'11px',xl:'16px'}, fontWeight:400, fontFamily: 'Rubik',  whiteSpace: 'nowrap',
  overflow: 'hidden', textOverflow: 'ellipsis' }}>{user?.email}</Typography></Box>

                            <Box    style={{ marginLeft: '1%', width:'20%'}}><Typography textAlign='left' sx={{fontSize: {xs:'8px',md:'9px',lg:'11px',xl:'16px'}, fontWeight:400, fontFamily: 'Rubik',  whiteSpace: 'nowrap',
  overflow: 'hidden', textOverflow: 'ellipsis'}}>{user?.organisation_name}</Typography></Box>

                            <Box   style={{ marginLeft: '1%', width:'15%'}}><Typography textAlign='left' sx={{fontSize: {xs:'10px',md:'11px',lg:'13px',xl:'19px'}, fontWeight:400, fontFamily: 'Rubik'}}>{user?.approved ? 'Unverified':'Pending Approval'}</Typography></Box>


                            {/* <Box    style={{ marginLeft: '1%', width:'20%'}}><Typography textAlign='left' sx={{fontSize: {xs:'10px',md:'11px',lg:'13px',xl:'19px'}, fontWeight:400, fontFamily: 'Rubik'}}></Typography></Box> */}



                           

                            <Box flex={1}  sx={{ display:'flex', justifyContent:'end',  minWidth:'15%'}}>
                            <Box sx={{fontSize: {xs:'8px',md:'9px',lg:'11px',xl:'16px'}, display:'flex', alignItems:'center',justifyContent:'end' }} gap={2}>
                
                            <>     
                            {user?.approved ? <>
            
                                <CustomButton 
                            btnText='Resend Link' 
                            // onClick={()=>dispatch(setAssetState({upload_files_popup:true}))} 
                              onClick={()=>resendUnverifiedUserLink({user_id:user?.id})} 
                            type='button'
                            // color='secondary'
                            variant='text'
                            style={{
                                borderRadius: '5px',
                                border: "none",          
                                textTransform:'none',
                    color:'green'
                                }}
                            sx={{fontSize:{xs:'10px',sm:'10px',md:'11px',lg:'12px',xl:'16px'}, fontWeight:600, height:{xs:'18px',sm:'18px',md:'20px',lg:'22px',xl:"36px"}, fontFamily:'Rubik',}}
                            />
                            </>:<>
                                <CustomButton 
                            btnText='Approve' 
                            onClick={()=>approveUser({user_id: user?.id, accepted:true})} 
                            type='button'
                            variant='text'
                            style={{
                                borderRadius: '5px',
                                border: "none",          
                                textTransform:'none',
                                color:'green'
                    
                                }}
                            sx={{fontSize:{xs:'10px',sm:'10px',md:'11px',lg:'12px',xl:'16px'}, fontWeight:600, height:{xs:'18px',sm:'18px',md:'20px',lg:'22px',xl:"36px"}, fontFamily:'Rubik'}}
                            />  
                              /
                              <CustomButton 
                            btnText='Reject' 
                            
                              onClick={()=>approveUser({user_id: user?.id, accepted:false})} 
                            type='button'
                         
                            variant='text'
                            style={{
                                borderRadius: '5px',
                                border: "none",          
                                textTransform:'none',
                                color:'red'
                    
                                }}
                            sx={{fontSize:{xs:'10px',sm:'10px',md:'11px',lg:'12px',xl:'16px'}, fontWeight:600, height:{xs:'18px',sm:'18px',md:'20px',lg:'22px',xl:"36px"}, fontFamily:'Rubik',}}
                            />
                            </>}
                           {/* { assetReducer?.delete_asset_loading === true && fileId == file?.id ?   <CircularProgress    
                                sx={{
                                  height:'3px', width:'3px',
                                  margin:{xs:0.75,md:0.87,lg:1.1, xl:1.4},
                                  color:'#666'
                                  }}
                                size={14}
                                loading={ assetReducer?.delete_asset_loading === true && fileId == file?.id}
                                disabled 
                              >    
                              </CircularProgress> : <IconButton  
                            disabled = {assetReducer?.delete_asset_loading === true}
                            onClick={()=>deleteFileHandler(file?.id)}
                             sx={{fontSize: {xs:'10px',md:'12px',lg:'15px',xl:'20px'}, '& .MuiSvgIcon-root':{
                            fontSize:{xs:'10px',md:'12px',lg:'15px',xl:'20px'}
                           }}}>
                            <DeleteIcon  sx={{fontSize: {xs:'10px',md:'12px',lg:'15px',xl:'20px'}, '& .MuiSvgIcon-root':{
                            fontSize:{xs:'10px',md:'12px',lg:'15px',xl:'20px'},
                           }}}/>
                         </IconButton>    }    */}

                            {/* <IconButton 
                             disabled = {assetReducer?.delete_asset_loading === true} 
                              onClick={()=>fileownloadHandler(file)} 
                              sx={{fontSize: {xs:'11px',md:'13px',lg:'16px',xl:'21px'}, 
                                  '& .MuiSvgIcon-root':{fontSize:{xs:'11px',md:'13px',lg:'16px',xl:'21px'},}}} 
                            >
                              <FileDownloadOutlinedIcon  sx={{fontSize: {xs:'11px',md:'13px',lg:'16px',xl:'21px'},  '& .MuiSvgIcon-root':{fontSize:{xs:'11px',md:'13px',lg:'16px',xl:'21px'},}}}/>
                            </IconButton> */}
                            </>
                        </Box>
                    </Box>
               </Box>
               ))} 

               </Box>
         
                
          
          {/* </>} */}
            </Box>
             
            </Box>
  )
}

export default UsersTable